// extracted by mini-css-extract-plugin
export default {"error":"error--P8TPt","blink":"blink--d_PVf"};